// extracted by mini-css-extract-plugin
export default {"container":"ProductCommentForm_container__E75N1","buttonsWrapper":"ProductCommentForm_buttonsWrapper__M5FIv"};